import { getHeaders } from "../utils";

export const APIGetTetraederToken = async (companyId, cityId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/partner/1.0/tetraeder/${companyId}/cityid/${cityId}`, requestOptions);
    const responseObject = await response.json();
    const token = responseObject?.data;
    return token;

  } catch (error) {
    console.error('Error:', error);
    throw error; // rethrow the error for further handling
  }
}